import React, { useContext, useState } from "react";
import Paragraph from "../Article/Paragraph";
import { LanguageContext, text } from "../../container/language";

import "./style.css";
import clsx from "clsx";

const CollapsableListItem = ({ title, body, collapsedByDefault = true }) => {
  const { userLanguage } = useContext(LanguageContext);
  const [collapsed, setCollapsed] = useState(collapsedByDefault);

  const classes = clsx({
    "accordion-list__item": true,
    "active-body": !collapsed,
  });

  return (
    <li class={classes}>
      <div
        class="accordion-list__header"
        onClick={() => setCollapsed(!collapsed)}
      >
        <div
          class="accordion-list__title"
          onClick={() => setCollapsed(!collapsed)}
        >
          <font style={{ verticalAlign: "inherit" }}>
            <font
              style={{ verticalAlign: "inherit" }}
              onClick={() => setCollapsed(!collapsed)}
            >
              {text(title, userLanguage)}
            </font>
          </font>
        </div>
      </div>
      <div
        class="accordion-list__body"
        style={{ display: collapsed ? "none" : "block" }}
      >
        <Paragraph data={body} className="text" />
      </div>
    </li>
  );
};

export const CollapsableList = ({ data }) => {
  return (
    <ul
      class="accordion-list accordion-list--alt"
      style={{ marginTop: "10px", marginBottom: "20px" }}
    >
      {data.map(({ title, body, id }, index) => (
        <CollapsableListItem
          title={title}
          body={body}
          key={id}
          collapsedByDefault={index != 0}
        />
      ))}
    </ul>
  );
};
